export default __webpack_public_path__ + "db6dea730dba697086b2269810a17660.svg";